/** PURE_IMPORTS_START ._DeferObservable PURE_IMPORTS_END */
import { DeferObservable } from './DeferObservable';
export var defer = DeferObservable.create;
//# sourceMappingURL=defer.js.map



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/Prod_web-client/node_modules/rxjs/_esm5/observable/defer.js
// module id = null
// module chunks = 